import React from "react";
import "./VerticalDivider.scss";

export const VerticalDivider = ({ className }) => {
	return <div className={`vertical-divider ${className ? className : ""}`}></div>;
};
